
export const PIXEL_TUTORIALS = 'PIXEL_TUTORIALS';

export const API_QUICK_START = 'API_QUICK_START';
export const API_AUDIO = 'API_AUDIO';
export const API_ENGINE = 'API_ENGINE';
export const API_FONT = 'API_FONT';
export const API_FONT_DATA = 'API_FONT_DATA';
export const API_FREQUENCIES = 'API_FREQUENCIES';
export const API_INPUT = 'API_INPUT';
export const API_KEYS = 'API_KEYS';
export const API_MAP_DATA = 'API_MAP_DATA';
export const API_NOTES = 'API_NOTES';
export const API_SCREEN = 'API_SCREEN';
export const API_SOUND = 'API_SOUND';
export const API_TILE_DATA = 'API_TILE_DATA';
export const API_TILE_MAP = 'API_TILE_MAP';

export const API_AUDIO_SNIPPETS = 'API_AUDIO_SNIPPETS';
export const API_SCREEN_SNIPPETS = 'API_SCREEN_SNIPPETS';
export const API_INPUT_SNIPPETS = 'API_INPUT_SNIPPETS';
